import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { FacilityProvider } from '../../providers/facility/facility';
import { ToastProvider } from '../../providers/toast/toast';
import { FacilitySelectLocationPage } from '../facility-select-location/facility-select-location';
import { AllBookingsPage } from '../all-bookings/all-bookings';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDetailsPage } from '../template-details/template-details'

@IonicPage()
@Component({
  selector: 'page-facility',
  templateUrl: 'facility.html',
})
export class FacilityPage {

  myBookings: any[];
  showData = false;
  locations: any[];
  lastBookingId : any;
  type : any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private facilityProvider: FacilityProvider,
    private toast: ToastProvider,
    private alertCtrl: AlertController) {

      this.type = this.navParams.get("type") 
      this.facilityProvider.getMyBookings().then(val => {
        if(val.status == "success"){
          this.myBookings = val.data;
          this.showData = true;
        }
      }).catch(e => {
        this.showData = true;
        this.toast.presentToast("Unable to load");
      });

      this.facilityProvider.getLocations('').then(val => {
        if(val.status == "success"){
          this.locations = val.data;
        }
      });


      // this.myBookings = [ {
      //   booking_from: '2021-08-02 10:00:00',
      //   booking_to: "2021-08-02 11:00:00",
      //   location_id : 100,
      //   id:100,
      //   user_id :200801,
      //   data : {"vehicle_no": "up14bu8326","name":"Aniket", "mobile_no":"7011283041" },
      //   reference_id : 230,
      //   location:{ address: "lskdnkl",availability_days: null,availability_slot: null,description: "asknaln",icon: null,id: 105,image: null,is_booking: 1,name: "PAriingggg",no_availability_days: "[]",rules: '{"tc": "<style type=\"text/css\">.car {background:red}\n</style>\n<div>\n<h1>Particular place</h1>\n\n<p class=\"car\">my nake is aniekt</p>\n</div>\n", "pre_defined_slot_only": "1"}',slot: '{"0":{"avl":true,"hrs":[{"from":"16:25","to":"17:25"},{"from":"17:25","to":"18:25"},{"from":"18:25","to":"19:25"}]}}',society_id: 21,type: "PARKING",updated_at: "2021-08-04 16:26:16",updated_by: "20604"}
      // } ]
  
  }

  doRefresh(refresher) {
    this.facilityProvider.getMyBookings().then(val => {
      if(val.status == "success"){
        this.myBookings = val.data;
      }
      refresher.complete();
    }).catch(e => {
      this.toast.presentToast("Unable to load");
      refresher.complete();
    });
  }

  cancelBooking(id: number, remarks: String){
    this.facilityProvider.cancelBooking(id, remarks).then(val => {
      if(val.status == "success"){
        this.myBookings.forEach((b, index) => {
          if(b.id == id){
            this.myBookings.splice(index, 1);
          }
        });
      }
      this.toast.presentToast(val.message);
    })
  }

  showAll(){
    this.navCtrl.push(AllBookingsPage);
  }

  showPrompt(id) {
    const prompt = this.alertCtrl.create({
      title: 'Cancel booking',
      message: "Do you really want to cancel your booking?",
      inputs: [
        {
          name: 'remarks',
          placeholder: 'Remarks'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

          }
        },
        {
          text: 'Ok',
          handler: data => {
            this.cancelBooking(id, data.remarks);
          }
        }
      ]
    });
    prompt.present();
  }

  book(){
      this.navCtrl.push(FacilitySelectLocationPage,{
        type:this.type
      });

  }

  compareDate(fromDate , toDate){
    var fd = new Date(fromDate).getDate();
    var td = new Date(toDate).getDate();
    if(fd == td){
      return true;
    }else{
      return false;
    }
  }
  

  showDetails(data){
  if(data.location.type == 'PARKING')
     this.navCtrl.push(TemplateDetailsPage,{
       data:data,
       type:'PARKING_RECEIPT_FORMAT'
     })
  }

  
  logDrag(event,bookingId){
    // console.log( this.lastBookingId ,bookingId)
    if(!this.lastBookingId || bookingId !=this.lastBookingId){    
    this.showPrompt(bookingId)
    }
   this.lastBookingId = bookingId
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad FacilityPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/facility/facility.ts